import { LOGIN_SUCCESS, LOGIN_FAILURE, LOGING_IN, AUTH_TOKEN, TOKEN_FAILURE } from '../actions/types';

//CHECK FOR TOKEN
let token = localStorage.getItem('token');

let initialState;
if((token == 'null') | (!token)){
    initialState = {
        isLogingIn: false,
        error: false,
        message: '',
        isLoggedIn: false,
        token: null
       
      }
} else {
    initialState = {
        isLogingIn: false,
        error: false,
        message: '',
        isLoggedIn: true,
        token: token
      }
}

export default (state = initialState, action) => {
    switch (action.type) {
        case LOGING_IN:
            return {
                ...state,
                isLogingIn: true,
                message: '',
                isLoggedIn: false,
            }
            break;
        case LOGIN_SUCCESS:
            return {
                ...state,
                isLogingIn: false,
                error: false,
                token: action.payload.token,
                message: '',
                isLoggedIn: true,
            }
            break;
        case LOGIN_FAILURE:
            return {
                ...state,
                isLogingIn: false,
                error: true,
                message: action.payload.message,
                isLoggedIn: false,
            }
            break;
        case AUTH_TOKEN:
            return {
                ...state,
                isLogingIn: false,
                error: false,
                token: action.payload.token,
                isLoggedIn: true,
                message: ''
            }
            break;
        case TOKEN_FAILURE:
            return {
                ...state,
                isLogingIn: false,
                error: false,
                message: '',
                token: null,
                isLoggedIn: false,
            }
        
        default:
            return state;
            break;
    }
}